import * as React from "react";
import { RecommendationKind } from "../App";
const ordinal = require("ordinal");

export interface RecommendationCategories {
	items?: RecommendationCategory[];
	selected?: string;
	kind: RecommendationKind;
}

export type RecommendationCategory = QuestionSubject | Textbook;

export interface SelectProps extends RecommendationCategories {
	clickHandler: () => void;
	changeHandler: (data: ChangeHandlerData) => void;
	error?: boolean;
	loading?: boolean;
}

export interface ChangeHandlerData {
	value: string;
	totalItems: number;
}

export interface QuestionSubject {
	id: number;
	title: string;
}

export interface Textbook {
	isbn13: string;
	groupId: number;
	title: string;
	edition: number;
}

const Select = (props: SelectProps) => {
	return props.items ? (
		<select
			data-test="cshp-recommendation-select"
			onChange={e =>
				props.changeHandler({
					totalItems: props.items.length,
					value: e.target.value,
				})
			}
			onClick={props.clickHandler}
			value={props.selected}
			disabled={props.loading}
			id={`cshp-recommendation-select-${props.kind}`}
		>
			{props.items.map(item => {
				let title: string;
				let value: string;
				let option: RecommendationCategory;
				if (props.kind === RecommendationKind.QnA) {
					option = item as QuestionSubject;
					title = option.title;
					value = option.id.toString();
				} else {
					let editionString = "";
					option = item as Textbook;
					if (option.edition) {
						editionString = `(${ordinal(option.edition)} Edition)`;
					}
					title = `${option.title} ${editionString}`.trimRight();
					value = `${option.isbn13}:${option.groupId}`;
				}
				return (
					<option key={value} value={value}>
						{title}
					</option>
				);
			})}
		</select>
	) : null;
};

Select.displayName = "Select";
export default Select;
